import { CHART_FIRM_SERVER_URL, CHART_PORTAL } from './../../app/app.constants';
import { UserDetail } from '../../app/modules/chart/interface/interfaces';
import { ReduxAction, ReduxType } from '../interface';

const data: UserDetail = {
  name: 'none',
  mail: undefined,
  appliance_id: '0',
  portalName: CHART_PORTAL,
  portalURL: CHART_FIRM_SERVER_URL,
  position_id: '-1',
  is_pos3_admin: false
};
export default (state: UserDetail, action: ReduxAction<UserDetail>) => {
  if (!state) {
    state = data;
  }
  switch (action.type) {
    case ReduxType.GET_USER:
      return Object.assign({}, state, action.payload);
    case ReduxType.USER_DEFAULT:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
};
